module.exports = __webpack_public_path__ + "img/favicon.94fc8af.png";